import React from "react";
import Section from "./Section";

export default function HTML_Colors() {
  return (
    <div className="tutorial-container">
      {/* 🔹 Title */}
      <h1 className="tutorial-title">🎨 HTML Colors</h1>

      {/* 🔹 Introduction */}
      <div
        style={{
          background: "linear-gradient(135deg, #f0f9ff, #e0f2fe)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
          marginBottom: "2rem",
        }}
      >
        <p className="tutorial-intro">
          HTML colors are used to style elements — for text, backgrounds,
          borders, and more. Colors can be defined using names, HEX codes, RGB,
          RGBA, HSL, or HSLA values.
        </p>
      </div>

      {/* Section 1️⃣ — Color Names */}
      <Section
        title="1️⃣ Color Names"
        html={`<h2 style="color: red;">Red Text</h2>
<p style="color: blue;">This text is blue.</p>
<p style="color: green;">This text is green.</p>`}
        description="HTML supports 140 standard color names such as red, blue, green, yellow, etc."
      />

      {/* Section 2️⃣ — Background Colors */}
      <Section
        title="2️⃣ Background Colors"
        html={`<h2 style="background-color: lightblue;">This has a light blue background</h2>
<p style="background-color: yellow;">This paragraph has a yellow background.</p>`}
        description="Use <code>background-color</code> to set the background color of an element."
      />

      {/* ✅ Summary */}
      <div
        style={{
          background: "linear-gradient(135deg, #f0f9ff, #e0f2fe)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2>📘 Summary — HTML Color Formats</h2>
        <ul className="tutorial-list-points">
          <li>
            <b>Color Names:</b> red, blue, green, yellow, etc.
          </li>
          <li>
            <b>HEX:</b> #RRGGBB
          </li>
          <li>
            <b>RGB:</b> rgb(red, green, blue)
          </li>
          <li>
            <b>RGBA:</b> adds transparency
          </li>
          <li>
            <b>HSL:</b> hue, saturation, lightness
          </li>
          <li>
            <b>HSLA:</b> adds transparency to HSL
          </li>
          <li>
            <b>Gradients:</b> for smooth color transitions
          </li>
        </ul>
      </div>
    </div>
  );
}
